"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var roosterjs_editor_api_1 = require("roosterjs-editor-api");
var roosterjs_editor_dom_1 = require("roosterjs-editor-dom");
var roosterjs_editor_core_1 = require("roosterjs-editor-core");
/**
 * IndentWhenTab edit feature, provides the ability to indent current list when user press TAB
 */
exports.IndentWhenTab = {
    keys: [9 /* TAB */],
    shouldHandleEvent: function (event, editor) {
        return !event.rawEvent.shiftKey && cacheGetListElement(event, editor);
    },
    handleEvent: function (event, editor) {
        roosterjs_editor_api_1.setIndentation(editor, 0 /* Increase */);
        event.rawEvent.preventDefault();
    },
};
/**
 * OutdentWhenShiftTab edit feature, provides the ability to outdent current list when user press Shift+TAB
 */
exports.OutdentWhenShiftTab = {
    keys: [9 /* TAB */],
    shouldHandleEvent: function (event, editor) {
        return event.rawEvent.shiftKey && cacheGetListElement(event, editor);
    },
    handleEvent: function (event, editor) {
        roosterjs_editor_api_1.setIndentation(editor, 1 /* Decrease */);
        event.rawEvent.preventDefault();
    },
};
/**
 * MergeInNewLine edit feature, provides the ability to merge current line into a new line when user press
 * BACKSPACE at beginning of a list item
 */
exports.MergeInNewLine = {
    keys: [8 /* BACKSPACE */],
    shouldHandleEvent: function (event, editor) {
        var li = roosterjs_editor_core_1.cacheGetElementAtCursor(editor, event, 'LI');
        var range = editor.getSelectionRange();
        return li && range && roosterjs_editor_dom_1.isPositionAtBeginningOf(roosterjs_editor_dom_1.Position.getStart(range), li);
    },
    handleEvent: function (event, editor) {
        var li = roosterjs_editor_core_1.cacheGetElementAtCursor(editor, event, 'LI');
        if (li.previousSibling) {
            editor.runAsync(function () {
                var br = editor.getDocument().createElement('BR');
                editor.insertNode(br);
                editor.select(br, -3 /* After */);
            });
        }
        else {
            toggleListAndPreventDefault(event, editor);
        }
    },
};
/**
 * OutdentWhenBackOn1stEmptyLine edit feature, provides the ability to outdent current item if user press
 * BACKSPACE at the first and empty line of a list
 */
exports.OutdentWhenBackOn1stEmptyLine = {
    keys: [8 /* BACKSPACE */],
    shouldHandleEvent: function (event, editor) {
        var li = roosterjs_editor_core_1.cacheGetElementAtCursor(editor, event, 'LI');
        return li && roosterjs_editor_dom_1.isNodeEmpty(li) && !li.previousSibling;
    },
    handleEvent: toggleListAndPreventDefault,
};
/**
 * OutdentWhenEnterOnEmptyLine edit feature, provides the ability to outdent current item if user press
 * ENTER at the beginning of an empty line of a list
 */
exports.OutdentWhenEnterOnEmptyLine = {
    keys: [13 /* ENTER */],
    shouldHandleEvent: function (event, editor) {
        var li = roosterjs_editor_core_1.cacheGetElementAtCursor(editor, event, 'LI');
        return !event.rawEvent.shiftKey && li && roosterjs_editor_dom_1.isNodeEmpty(li);
    },
    handleEvent: function (event, editor) {
        editor.performAutoComplete(function () { return toggleListAndPreventDefault(event, editor); });
    },
};
/**
 * AutoBullet edit feature, provides the ablility to automatically convert current line into a list.
 * When user input "1. ", convert into a numbering list
 * When user input "- " or "* ", convert into a bullet list
 */
exports.AutoBullet = {
    keys: [32 /* SPACE */],
    shouldHandleEvent: function (event, editor) {
        if (!cacheGetListElement(event, editor)) {
            var searcher = roosterjs_editor_core_1.cacheGetContentSearcher(event, editor);
            var textBeforeCursor = searcher.getSubStringBefore(3);
            // Auto list is triggered if:
            // 1. Text before cursor exactly mathces '*', '-' or '1.'
            // 2. There's no non-text inline entities before cursor
            return (['*', '-', '1.'].indexOf(textBeforeCursor) >= 0 &&
                !searcher.getNearestNonTextInlineElement());
        }
        return false;
    },
    handleEvent: function (event, editor) {
        editor.runAsync(function () {
            editor.performAutoComplete(function () {
                var searcher = editor.getContentSearcherOfCursor();
                var textBeforeCursor = searcher.getSubStringBefore(3);
                var rangeToDelete = searcher.getRangeFromText(textBeforeCursor, true /*exactMatch*/);
                if (rangeToDelete) {
                    rangeToDelete.deleteContents();
                    var node = rangeToDelete.startContainer;
                    if ((node === null || node === void 0 ? void 0 : node.nodeType) == 3 /* Text */ &&
                        node.nodeValue == '' &&
                        !node.previousSibling &&
                        !node.nextSibling) {
                        var br = editor.getDocument().createElement('BR');
                        editor.insertNode(br);
                        editor.select(br, -2 /* Before */);
                    }
                }
                if (textBeforeCursor.indexOf('1.') == 0) {
                    roosterjs_editor_api_1.toggleNumbering(editor);
                }
                else {
                    roosterjs_editor_api_1.toggleBullet(editor);
                }
            });
        });
    },
};
/**
 * Get an instance of SmartOrderedList edit feature. This feature provides the ability to use different
 * number style for different level of numbering list.
 * @param styleList The list of number styles used for this feature.
 * See https://www.w3schools.com/cssref/pr_list-style-type.asp for more information
 */
function getSmartOrderedList(styleList) {
    return {
        keys: [2048 /* CONTENTCHANGED */],
        shouldHandleEvent: function (event, editor) { return roosterjs_editor_dom_1.isHTMLOListElement(event.data); },
        handleEvent: function (event, editor) {
            var ol = event.data;
            var parentOl = editor.getElementAtCursor('OL', ol.parentNode);
            if (parentOl) {
                // The style list must has at least one value. If no value is passed in, fallback to decimal
                var styles = styleList && styleList.length > 0 ? styleList : ['decimal'];
                ol.style.listStyle =
                    styles[(styles.indexOf(parentOl.style.listStyle) + 1) % styles.length];
            }
        },
    };
}
exports.getSmartOrderedList = getSmartOrderedList;
function toggleListAndPreventDefault(event, editor) {
    var listInfo = cacheGetListElement(event, editor);
    if (listInfo) {
        var listElement = listInfo[0];
        var tag = roosterjs_editor_dom_1.getTagOfNode(listElement);
        if (tag == 'UL') {
            roosterjs_editor_api_1.toggleBullet(editor);
        }
        else if (tag == 'OL') {
            roosterjs_editor_api_1.toggleNumbering(editor);
        }
        editor.focus();
        event.rawEvent.preventDefault();
    }
}
function cacheGetListElement(event, editor) {
    var li = roosterjs_editor_core_1.cacheGetElementAtCursor(editor, event, 'LI,TABLE');
    var listElement = li && roosterjs_editor_dom_1.getTagOfNode(li) == 'LI' && editor.getElementAtCursor('UL,OL', li);
    return listElement ? [listElement, li] : null;
}
//# sourceMappingURL=listFeatures.js.map